import { useShareLink } from '@bridebook/web/lib/share/use-share-link';
import { useTranslation } from 'next-i18next';
import { useWeddingWebsiteUrl } from './use-wedding-website-url';

export const useShareWeddingWebsite = ({
  overrideNative,
  linkToRsvp,
}: {
  overrideNative?: boolean;
  linkToRsvp?: boolean;
} = {}) => {
  const { t } = useTranslation('weddingWebsite');
  const { websiteUrl, mainPath, secondaryPath, websiteId } = useWeddingWebsiteUrl(linkToRsvp);

  const { shareLink: shareWeddingWebsite } = useShareLink({
    overrideNative,
    url: websiteUrl,
    shareTitle: t('shareLink.title'),
    shareText: t('shareLink.text'),
    shareModalProps: {
      title: t('shareModal.title'),
      subtitle: t('shareModal.subtitle'),
    },
  });

  return { shareWeddingWebsite, mainPath, secondaryPath, websiteId, websiteUrl };
};
